<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<div class="driver-view">
  <div>
    <div class="heading">
      <h3>Trucks Add</h3>
    </div>
    <mat-divider></mat-divider>
    <form [formGroup]="truckAddFrom" class="admin-forms truckComponent mt-3">
      <div class="input-fileds-container category-edit">
        <div class="row">
          <div class="col-sm-9">
            <!-- Truck RC Verification Box -->
                <div class="rc-verify-box">
                  <div class="rc-verify-box-header">
                    <div class="rc-verify-title">
                      <img src="../../../assets/img/tick-verify.svg" *ngIf="isRcVerified" class="verify-icon-success" />
                      <span>Truck RC Verification</span>
                    </div>
                    <div class="rc-verify-subtitle" *ngIf="!isRcVerified">
                      Enter Truck Number, then click Verify
                    </div>
                    <div class="rc-verify-subtitle text-success" *ngIf="isRcVerified">
                      ✓ Verified with VAHAN National Registry
                    </div>
                  </div>

                  <div>
                    <div class="head">Truck Number<span class="required-asterisk">*</span></div>
                    <div class="truck-verify-wrapper">
                      <mat-form-field class="truck-input-field">
                        <input
                          toUppercase
                          appAlphanumericOnly
                          matInput
                          formControlName="truck_number"
                          maxlength="10"
                          minlength="6"
                          placeholder="e.g. MH12AB1234"
                          required
                          #newItem
                          (input)="onTruckNumberChange(newItem.value)"
                          [readonly]="isFieldRestricted('truck_number')"
                          [class.field-restricted]="isFieldRestricted('truck_number')"
                        />
                        <mat-error>Please enter truck number</mat-error>
                      </mat-form-field>

                      <div class="verify-btn-container">
                        <button
                          type="button"
                          class="verify-action-btn"
                          (click)="verifyVehicleRC()"
                          [disabled]="isRcVerifying"
                          *ngIf="!isRcVerified"
                          title="Verify Truck RC with VAHAN"
                        >
                          <span *ngIf="!isRcVerifying">Verify</span>
                          <span *ngIf="isRcVerifying" class="inline-spinner-white"></span>
                        </button>

                        <div *ngIf="isRcVerified" class="d-flex align-items-center gap-1 verify-status-wrapper">
                          <img src="../../../assets/img/tick-verify.svg" style="width: 24px; height: 24px;" title="Verified with VAHAN" />
                          <a
                            (click)="resetRcVerification()"
                            class="change-dl-link"
                            title="Change Truck Number / Re-verify"
                            >Change</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Verified RC Information Card inside the box -->
                  <div class="mt-2" *ngIf="isRcVerified && rcVerificationData">
                    <div class="rc-verified-card">
                      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div class="rc-meta">
                          <span class="meta-label">Class:</span>
                          <span class="meta-value">{{ rcVerificationData.vehicle_class || rcVerificationData.category || 'Goods Carrier' }}</span>
                          <span class="meta-divider" *ngIf="rcVerificationData.fuel">•</span>
                          <span class="meta-label" *ngIf="rcVerificationData.fuel">Fuel:</span>
                          <span class="meta-value" *ngIf="rcVerificationData.fuel">{{ rcVerificationData.fuel }}</span>
                          <span class="meta-divider" *ngIf="rcVerificationData.body_type">•</span>
                          <span class="meta-label" *ngIf="rcVerificationData.body_type">Body:</span>
                          <span class="meta-value" *ngIf="rcVerificationData.body_type">{{ rcVerificationData.body_type }}</span>
                          <span class="meta-divider" *ngIf="rcVerificationData.gvw || rcVerificationData.unladen_weight">•</span>
                          <span class="meta-label" *ngIf="rcVerificationData.gvw">GVW:</span>
                          <span class="meta-value" *ngIf="rcVerificationData.gvw">{{ rcVerificationData.gvw }} kg</span>
                          <span class="meta-label" *ngIf="!rcVerificationData.gvw && rcVerificationData.unladen_weight">Weight:</span>
                          <span class="meta-value" *ngIf="!rcVerificationData.gvw && rcVerificationData.unladen_weight">{{ rcVerificationData.unladen_weight }} kg (Unladen)</span>
                        </div>
                        <div class="rc-badge-wrapper">
                          <span class="badge-rc-verified">
                            ✓ VAHAN Verified ({{ rcVerificationData.status || 'Active' }})
                          </span>
                        </div>
                      </div>
                      <div *ngIf="rcVerificationData.insurance_company" class="mt-1" style="font-size: 11px; color: #475569;">
                        <strong>Insurance:</strong> {{ rcVerificationData.insurance_company }}
                        <span *ngIf="rcVerificationData.insurance_policy"> (Policy: {{ rcVerificationData.insurance_policy }})</span>
                        <span *ngIf="rcVerificationData.insurance_expiry"> (Valid upto: {{ rcVerificationData.insurance_expiry }})</span>
                      </div>
                      <div *ngIf="rcVerificationData.financer" class="mt-1" style="font-size: 11px; color: #475569;">
                        <strong>Financer:</strong> {{ rcVerificationData.financer }}
                        <span *ngIf="rcVerificationData.registered_at"> • <strong>Registered at:</strong> {{ rcVerificationData.registered_at }}</span>
                      </div>
                    </div>
                  </div>
                </div>
            <div class="row mtb">
              <div class="col-sm-5">
                <mat-form-field>
                  <mat-label>Home Location</mat-label>
                  <input matInput formControlName="home_location" [readonly]="isFieldRestricted('home_location')" [class.field-restricted]="isFieldRestricted('home_location')" />
                </mat-form-field>
              </div>
              <div class="col-sm-7">
                <mat-form-field>
                  <mat-label>Make Name</mat-label>
                  <input matInput formControlName="make_name" [readonly]="isFieldRestricted('make_name')" [class.field-restricted]="isFieldRestricted('make_name')" />
                </mat-form-field>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-5">
                <mat-form-field>
                  <mat-label>Model</mat-label>
                  <input matInput formControlName="truck_model" [readonly]="isFieldRestricted('truck_model')" [class.field-restricted]="isFieldRestricted('truck_model')" />
                </mat-form-field>
              </div>
              <div class="col-sm-7">
                <mat-form-field>
                  <mat-label>Manufacturing Year</mat-label>
                  <input
                    type="number"
                    matInput
                    formControlName="manufacture_year" [readonly]="isFieldRestricted('manufacture_year')" [class.field-restricted]="isFieldRestricted('manufacture_year')"
                    maxlength="4"
                    minlength="4"
                  />
                  <mat-error>Please enter manufacture year</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row mtb mt-3 trucksselect">
              <div class="col-sm-5">
                <mat-form-field
                  class="flex-gt-sm example-full-width truck-type-input"
                >
                  <mat-label>Truck Category</mat-label>
                  <mat-select
                    dropLocationSearchField
                    formControlName="truck_category"
                    (selectionChange)="gettruckCatg($event)"
                    required
                  >
                    <mat-option
                      *ngFor="let cat of truckCategory"
                      value="{{ cat._id }}"
                    >
                      {{ cat.truck_category_name }}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please select truck category</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-6">
                <mat-form-field>
                  <mat-label>Truck Type</mat-label>
                  <mat-select
                    dropLocationSearchField
                    formControlName="truck_type"
                    required
                  >
                    <mat-option
                      *ngFor="let cat of truckTypeList"
                      value="{{ cat._id }}"
                    >
                      {{ cat.truck_weight }}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please enter Truck Type</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div [class.spinner]="truckImageloading"></div>

            <div class="right-img" *ngIf="!profileImg">
              <img src="{{ truckImage }}" class="driverImg" />
              <img
                src="../../../assets/img/icons8-macos-close-60.png"
                *ngIf="!profileImg"
                (click)="removeImg($event, 'Truck')"
                class="cross-btn"
                alt=""
              />
            </div>

            <div *ngIf="profileImg" class="image-upload-area">
              <span (click)="uploadTruckImage.click()" class="image mt-4"
                ><img src="../../../assets/img/profile-upload.svg"
              /></span>
              <input
                #uploadTruckImage
                type="file"
                formControlName="truck_image"
                (change)="onChange($event, 'Truck')"
                hidden
              />
            </div>
          </div>
        </div>
        <p>Documents</p>
        <div class="row">
          <div class="col-md-12">
            <div class="row mtb">
              <div class="col-sm-4 d-flex align-items-center">
                <div>Vehicle RC</div>
              </div>
              <div class="col-sm-4">
                <mat-form-field
                  class="flex-gt-sm example-full-width truck-type-input"
                >
                  <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3" [disabled]="isFieldRestricted('vehicle_rc_expiry')">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker1 [disabled]="isFieldRestricted('vehicle_rc_expiry')"></mat-datepicker>
                  <input
                    matInput
                    formControlName="vehicle_rc_expiry" [readonly]="isFieldRestricted('vehicle_rc_expiry')" [class.field-restricted]="isFieldRestricted('vehicle_rc_expiry')"
                    [matDatepicker]="picker1"
                    placeholder="DD-MM-YYYY"
                    [min]="minDate"
                    (click)="!isFieldRestricted('vehicle_rc_expiry') && picker1.open()"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-sm-4 d-flex align-items-center justify-content-center"
              >
                <span
                  (click)="uploadRCImage.click()"
                  *ngIf="uploadVehicle"
                  class="image"
                  >Upload
                </span>
                <div [class.spinner]="rcLoading"></div>

                <span *ngIf="!uploadVehicle">{{ RCImageName }}</span>
                <img
                  src="../../../assets/img/cross.svg"
                  *ngIf="!uploadVehicle"
                  (click)="removeImg($event, 'RC')"
                  class="cross-btn"
                  alt=""
                />
                <input
                  #uploadRCImage
                  type="file"
                  formControlName="vehicle_rc"
                  (change)="onChange($event, 'RC')"
                  hidden
                />
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-4 d-flex align-items-center">
                <div class="">Permit Type</div>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3" [disabled]="isFieldRestricted('permit_type_expiry')">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker2 [disabled]="isFieldRestricted('permit_type_expiry')"></mat-datepicker>
                  <input
                    matInput
                    [matDatepicker]="picker2"
                    placeholder="DD-MM-YYYY"
                    [min]="minDate"
                    formControlName="permit_type_expiry"
                    [readonly]="isFieldRestricted('permit_type_expiry')"
                    [class.field-restricted]="isFieldRestricted('permit_type_expiry')"
                    (click)="!isFieldRestricted('permit_type_expiry') && picker2.open()"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-sm-4 d-flex align-items-center justify-content-center"
              >
                <span
                  (click)="uploadPermitImage.click()"
                  *ngIf="uploadPermit"
                  class="image"
                  >Upload
                </span>
                <div [class.spinner]="permitLoading"></div>

                <span *ngIf="!uploadPermit">{{ permitImageName }}</span>
                <img
                  src="../../../assets/img/cross.svg"
                  *ngIf="!uploadPermit"
                  (click)="removeImg($event, 'permit')"
                  class="cross-btn"
                  alt=""
                />
                <input
                  #uploadPermitImage
                  type="file"
                  formControlName="permit_type"
                  (change)="onChange($event, 'PermitType')"
                  hidden
                />
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-4 d-flex align-items-center">
                <div class="">Fitness</div>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-datepicker-toggle matSuffix [for]="picker3" class="ms-3" [disabled]="isFieldRestricted('fitness_expiry')">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker3 [disabled]="isFieldRestricted('fitness_expiry')"></mat-datepicker>
                  <input
                    matInput
                    [matDatepicker]="picker3"
                    placeholder="DD-MM-YYYY"
                    [min]="minDate"
                    formControlName="fitness_expiry"
                    [readonly]="isFieldRestricted('fitness_expiry')"
                    [class.field-restricted]="isFieldRestricted('fitness_expiry')"
                    (click)="!isFieldRestricted('fitness_expiry') && picker3.open()"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-sm-4 d-flex align-items-center justify-content-center"
              >
                <span
                  (click)="uploadFitnesstImage.click()"
                  *ngIf="uploadFitness"
                  class="image"
                  >Upload
                </span>
                <div [class.spinner]="fitnessLoading"></div>

                <span *ngIf="!uploadFitness">{{ fitnessImageName }}</span>
                <img
                  src="../../../assets/img/cross.svg"
                  *ngIf="!uploadFitness"
                  (click)="removeImg($event, 'fitness')"
                  class="cross-btn"
                  alt=""
                />
                <input
                  #uploadFitnesstImage
                  type="file"
                  formControlName="firness"
                  (change)="onChange($event, 'Fitness')"
                  hidden
                />
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-4 d-flex align-items-center">
                <div class="">Pollution</div>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-datepicker-toggle matSuffix [for]="picker4" class="ms-3" [disabled]="isFieldRestricted('pollution_expiry')">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker4 [disabled]="isFieldRestricted('pollution_expiry')"></mat-datepicker>
                  <input
                    matInput
                    [matDatepicker]="picker4"
                    placeholder="DD-MM-YYYY"
                    [min]="minDate"
                    formControlName="pollution_expiry"
                    [readonly]="isFieldRestricted('pollution_expiry')"
                    [class.field-restricted]="isFieldRestricted('pollution_expiry')"
                    (click)="!isFieldRestricted('pollution_expiry') && picker4.open()"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-sm-4 d-flex align-items-center justify-content-center"
              >
                <span
                  (click)="uploadPollutionImage.click()"
                  *ngIf="uploadPollution"
                  class="image"
                  >Upload
                </span>
                <div [class.spinner]="pollutionLoading"></div>

                <span *ngIf="!uploadPollution">{{ pollutionImageName }}</span>
                <img
                  src="../../../assets/img/cross.svg"
                  *ngIf="!uploadPollution"
                  (click)="removeImg($event, 'pollution')"
                  class="cross-btn"
                  alt=""
                />
                <input
                  #uploadPollutionImage
                  type="file"
                  formControlName="pollution"
                  (change)="onChange($event, 'Pollution')"
                  hidden
                />
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-4 d-flex align-items-center">
                <div class="">Insurance</div>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-datepicker-toggle matSuffix [for]="picker5" class="ms-3" [disabled]="isFieldRestricted('insurance_expiry')">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker5 [disabled]="isFieldRestricted('insurance_expiry')"></mat-datepicker>
                  <input
                    matInput
                    [matDatepicker]="picker5"
                    placeholder="DD-MM-YYYY"
                    [min]="minDate"
                    formControlName="insurance_expiry"
                    [readonly]="isFieldRestricted('insurance_expiry')"
                    [class.field-restricted]="isFieldRestricted('insurance_expiry')"
                    (click)="!isFieldRestricted('insurance_expiry') && picker5.open()"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-sm-4 d-flex align-items-center justify-content-center"
              >
                <span
                  (click)="uploadInsuranceImage.click()"
                  *ngIf="uploadInsurance"
                  class="image"
                  >Upload
                </span>
                <div [class.spinner]="insuranceLoading"></div>

                <span *ngIf="!uploadInsurance">{{ insuranceImageName }}</span>
                <img
                  src="../../../assets/img/cross.svg"
                  *ngIf="!uploadInsurance"
                  (click)="removeImg($event, 'insurance')"
                  class="cross-btn"
                  alt=""
                />
                <input
                  #uploadInsuranceImage
                  type="file"
                  formControlName="insurance"
                  (change)="onChange($event, 'Insurance')"
                  hidden
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <button
            type="button"
            [class.spinner]="loading"
            [disabled]="loading"
            class="button buttonBlue mt-3"
            (click)="addTruck($event)"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
